export default {
  STEP: `Paso {{step}} de {{steps}}`,
  NEXT_STEP: `Próximo paso`,
  PREVIOUS_STEP: `Paso anterior`,
  DEVICECHECK_WELCOME_HEADING: `Comencemos`,
  DEVICECHECK_WELCOME_INSTRUCTIONS: `Haz clic en “Permitir” (Allow) cuando tu navegador pida acceso a tu cámara y micrófono.`,
  DEVICECHECK_WELCOME_START_BTN: `Verificar el dispositivo`,
  DEVICECHECK_WELCOME_BROWSER_CHECK: `Verificar\nnavegador`,
  DEVICECHECK_WELCOME_AV_CHECK: `Verificar audio\ny video`,
  DEVICECHECK_WELCOME_ALL_SETUP: `¡Estás\nlisto!`,
  DEVICECHECK_WELCOME_FIRST_STEP_COMPLETED: `Primer paso completado`,

  DEVICECHECK_COMPLETE_HEADING: `¡Buen trabajo!\nYa está todo listo.`,
  DEVICECHECK_COMPLETE_CONTENT: `<0>Esperamos verte a la hora de tu cita.</0><1>Ahora puedes cerrar esta ventana.</1>`,
  DEVICECHECK_COMPLETE_FAQ_BTN: `Visita nuestras preguntas frecuentes`,

  SPEAKER_TEST_HEADER: `Prueba de Altavoz`,
  PLEASE_SELECT_DEVICE: `Selecciona tu dispositivo de salida.`,
  DO_YOU_HEAR_SOUND: `¿Escuchas el sonido?`,
  PRESS_PLAY_SOUND: `Selecciona el botón “Reproducir Sonido” (Play Sound).`,
  PLAY_BUTTON: `Reproducir Sonido`,
  CHANGE_SPEAKERS: `Si necesitas cambiar tus altavoces, usa las preferencias de tu dispositivo.`,
  MY_DEVICE_SOUND_IS_GOOD: `Mi dispositivo tiene el volumen subido y conozco mi configuración de Bluetooth.`,
  YES_I_HEAR_IT: `Sí, lo escucho`,
  TROUBLESHOOT_SPEAKERS: `Solucionar problemas con tus altavoces`,

  CAMERA_TEST_HEADER: `Prueba de Cámara`,
  NO_CAMERA: `No podemos detectar una cámara, pero aún puedes asistir a tu cita con audio\u00A0solamente.`, // use \u00A0 to prevent single orphan words on new lines
  OK: `OK`,
  HELP_WITH_CAMERA_DETECTION: `Obtén ayuda con la detección de cámara`,
  DO_YOU_SEE_YOURSELF_IN_YOUR_CAMERA: `¿Te ves a ti mismo?`,
  I_UNDERSTAND_CAMERA_ABILITIES: `Sé que puedo apagar mi cámara durante mi cita si no quiero que me vean.`,
  YES_I_SEE_MYSELF: `Sí, me veo a mí mismo`,
  TROUBLESHOOT_CAMERA: `Solucionar problemas con tu cámara`,
  YOUR_CAMERA_VIEW: `Video de tu cámara`,
  CAMERA_LOADING: `Cámara cargando ...`,

  MICROPHONE_TEST_HEADER: `Prueba el Micrófono`,
  SAY_SOMETHING: `Di algo.`,
  YOU_SEE_THE_BAR_MOVING: `¿Ves moverse la barra de audio?`,
  MY_ENVIRONMENT_IS_PERFECT_FOR_CALLS: `Tengo un mínimo ruido de fondo y puedo lograr que mi llamada no se interfiera.`,
  TROUBLESHOOT_MICROPHONE: `Solucionar problemas de tu micrófono`,
  MICROPHONE_SOUND_LEVEL: `Nivel de sonido del micrófono`,
  YES_I_SEE_IT: `Sí, lo veo`,
  NO_I_NEED_HELP: `No, necesito ayuda`,

  ERROR_PAGE_TITLE: `Vaya, algo hicimos mal`,
  ERROR_PAGE_HELP_1: `Trata de actualizar tu navegador o contacta con tu consultorio.`,
  ERROR_PAGE_HELP_2: `Gracias por tu paciencia mientras resolvemos problemas técnicos.`,
  INVALID_APPT_PAGE: `<0>Vaya, este vínculo no está activo</0><1>Este vínculo está activo solo el día de tu cita.<br role="presentation"><br role="presentation">Mientras tanto, dedica un momento a asegurarte de que todo esté funcionando bien con nuestra rápida verificación de dispositivos.</1>`,
  INVALID_APPT_PAGE_START_DEVICE_CHECK: `Checar Dispositivo`,
  INVALID_APPT_PAGE_MESSAGE_IN_ERROR: `Si piensas que has recibido este mensaje por error, contacta con tu consultorio.`,

  INVALID_DEEPLINK_TITLE: `Este enlace no está disponible`,
  INVALID_DEEPLINK_CONTENT: `Accede al portal de tu consultorio o a los recordatorios de tu cita para ver el enlace de la visita.`,
};
